import { Icon } from '@/components/atoms'
import { LEGACY_URL_PLACEHOLDER } from '@/utils/constants'
import classnames from 'classnames'
import { useTranslation } from 'react-i18next'

interface SidebarLegacyLinkProps {
    isCollapsed: boolean
}

const SidebarLegacyLink: React.FC<SidebarLegacyLinkProps> = ({
    isCollapsed,
}) => {
    const { t } = useTranslation('translations')

    const linkClassName = classnames(
        'text-label-xsmall grid mb-0.5 w-full max-w-[208px] min-h-10 rounded-lg border border-azure bg-blue-50 px-4 py-2 leading-4 text-regular focus:outline-4 transition-all',
        {
            'gap-1 grid-cols-[min-content_1fr]': !isCollapsed,
            'gap-0 grid-cols-[min-content_0fr]': isCollapsed,
        }
    )

    const linkDescriptionClassName = classnames(
        'max-h-12 overflow-hidden transition-all',
        {
            'h-0 w-0 whitespace-nowrap': isCollapsed,
            'h-auto w-auto whitespace-normal': !isCollapsed,
        }
    )

    return (
        <a
            href={LEGACY_URL_PLACEHOLDER}
            className={linkClassName}
            target="_blank"
            data-testid="legacy-url"
            rel="noreferrer"
            id="legacy-url"
            data-walkthrough="legacy-app-sidebar-notification"
        >
            <Icon
                name="open_in_new"
                data-testid="legacy-url-icon"
                className="text-azure transition-all"
                size={isCollapsed ? 'medium' : 'small'}
            />

            <span
                className={linkDescriptionClassName}
                dangerouslySetInnerHTML={{
                    __html: t('sidebar_menu.legacy_link.description'),
                }}
            ></span>
        </a>
    )
}

export default SidebarLegacyLink
